import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { Button, CustomInput, RangeSlider } from '@kiper/ui';
import { ColorField, FileField, TextAreaField } from './components';
import * as S from './styles';

const BANNER_FOCUS_FIELD = 'bannerFocus';

const GeneratorForm = ({ values, errors, onFieldChange, onGenerate }) => {
  const [t] = useTranslation('personalized-invite');

  const getError = field =>
    errors[field] ? t(`generator.errors.${errors[field]}`) : '';

  const handleBannerFocusChange = event =>
    onFieldChange(BANNER_FOCUS_FIELD, Number(event.target.value));

  return (
    <S.Form>
      <S.Section>
        <CustomInput
          name="clientName"
          label={t('generator.fields.client-name')}
          value={values.clientName}
          error={getError('clientName')}
          onChange={onFieldChange}
          required
        />
        <S.Field>
          <CustomInput
            name="personContextId"
            label={t('generator.fields.person-context-id')}
            value={values.personContextId}
            error={getError('personContextId')}
            onChange={onFieldChange}
            inputMode="numeric"
            required
          />
          <S.Hint>{t('generator.fields.person-context-id-hint')}</S.Hint>
        </S.Field>
      </S.Section>

      <S.Section>
        <ColorField
          name="primaryColor"
          label={t('generator.fields.primary-color')}
          value={values.primaryColor}
          error={getError('primaryColor')}
          onChange={onFieldChange}
        />
        <ColorField
          name="secondaryColor"
          label={t('generator.fields.secondary-color')}
          value={values.secondaryColor}
          error={getError('secondaryColor')}
          onChange={onFieldChange}
        />
      </S.Section>

      <S.Section>
        <FileField
          name="logoFile"
          label={t('generator.fields.logo')}
          error={getError('logoFile')}
          onChange={onFieldChange}
        />
        <FileField
          name="bannerFile"
          label={t('generator.fields.banner')}
          error={getError('bannerFile')}
          onChange={onFieldChange}
        />
        <S.Field>
          <S.RangeLabel htmlFor={BANNER_FOCUS_FIELD}>
            {t('generator.fields.banner-focus', { value: values.bannerFocus })}
          </S.RangeLabel>
          <RangeSlider
            id={BANNER_FOCUS_FIELD}
            name={BANNER_FOCUS_FIELD}
            min={0}
            max={100}
            step={1}
            length={240}
            value={values.bannerFocus}
            onChange={handleBannerFocusChange}
          />
          <S.Hint>{t('generator.fields.banner-focus-hint')}</S.Hint>
        </S.Field>
      </S.Section>

      <S.Section>
        <TextAreaField
          name="hostMessage"
          label={t('generator.fields.host-message')}
          value={values.hostMessage}
          onChange={onFieldChange}
        />
        <TextAreaField
          name="condominiumNotice"
          label={t('generator.fields.condominium-notice')}
          value={values.condominiumNotice}
          onChange={onFieldChange}
        />
      </S.Section>

      <Button onClick={onGenerate}>{t('generator.actions.generate')}</Button>
    </S.Form>
  );
};

GeneratorForm.propTypes = {
  values: propTypes.shape({
    clientName: propTypes.string,
    personContextId: propTypes.string,
    primaryColor: propTypes.string,
    secondaryColor: propTypes.string,
    bannerFocus: propTypes.number,
    hostMessage: propTypes.string,
    condominiumNotice: propTypes.string,
  }).isRequired,
  errors: propTypes.objectOf(propTypes.string),
  onFieldChange: propTypes.func.isRequired,
  onGenerate: propTypes.func.isRequired,
};

GeneratorForm.defaultProps = {
  errors: {},
};

export default GeneratorForm;
